export class CheckIfExistsSectorUseCase {
  constructor(farmsDapRepository) {
    this.sectorHasFarmRepository=farmsDapRepository
  }
  async execute(ID_FARM) {
    // ID_FARM  -> ID do Cultivar
    //Verificar se existe cultivares com ID_FARM no banco
    const farms=await this.sectorHasFarmRepository.checkIfExistsFarm(ID_FARM)
    return farms
  }
}
